// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"1e3db92e9e59b0cd","234":"bb68a017491dd34a","464":"aa03a5e824c55a0a","545":"52cb47b7d7f3abe0","554":"fedf2ef5cb7b24fe","556":"b35df8bf8ab1e64a","707":"50927b1615ca79ef","718":"bf4edd934e584a41"}[chunkId] + ".js";
};